var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrTournamentTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 6.017a.488.488 0 00.487-.487.481.481 0 00-.486-.486H9.569a.481.481 0 00-.486.486c0 .263.214.487.486.487h1.945v4.452c0 .273.214.487.486.487a.481.481 0 00.486-.487V6.017h1.944z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.82.222h22.36c.273 0 .487.214.487.486v4.91a2.658 2.658 0 00-.487-.049 2.43 2.43 0 10.486 4.813v4.91a.481.481 0 01-.486.486H.82a.481.481 0 01-.487-.486v-4.91c.156.03.321.049.486.049a2.43 2.43 0 10-.486-4.813V.708C.333.436.547.222.82.222zm21.874 11.132A3.396 3.396 0 0119.778 8a3.396 3.396 0 012.916-3.354V1.194H1.305v3.452A3.396 3.396 0 014.222 8a3.396 3.396 0 01-2.917 3.354v3.452h21.39v-3.452z"
  })));
}
SvgPrTournamentTickets.displayName = 'PrTournamentTickets';
export default SvgPrTournamentTickets;